<template>
  <el-dialog class="detail"
             :visible.sync="detailVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1000px"
             :title="$t('storeList.add.dialogTitle_detail')"
             :modal-append-to-body="false"
             append-to-body>
    <div class="container"
         v-loading='loading'>
      <el-form ref="detailForm"
               :model="detailForm"
               label-width="100px" @keydown.enter.native.prevent>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('storeList.add.name')"
                          size="small">
              <el-input disabled
                        :placeholder="`${$t('storeList.add.inputPlaceholder')}${$t('storeList.add.name')}`"
                        maxlength="100"
                        size="small"
                        v-model="detailForm.name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeList.add.shop_abbr')"
                          size="small">
              <el-input disabled
                        :placeholder="`${$t('storeList.add.inputPlaceholder')}${$t('storeList.add.shop_abbr')}`"
                        maxlength="100"
                        size="small"
                        v-model.number="detailForm.shop_abbr">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeList.add.platform_id')"
                          size="small">
              <el-input disabled
                        :placeholder="`${$t('storeList.add.selectPlaceholder')}${$t('storeList.add.platform_id')}`"
                        maxlength="100"
                        size="small"
                        v-model="detailForm.platform_name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeList.add.open_date')"
                          size="small">
              <el-input disabled
                        :placeholder="`${$t('storeList.add.selectPlaceholder')}${$t('storeList.add.open_date')}`"
                        maxlength="100"
                        size="small"
                        v-model="detailForm.open_date">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeList.add.shop_url')"
                          size="small">
              <el-input disabled
                        :placeholder="`${$t('storeList.add.inputPlaceholder')}${$t('storeList.add.shop_url')}`"
                        maxlength="100"
                        v-model="detailForm.shop_url">
                <template slot="prepend">
                  {{detailForm.http_type}}
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeList.add.shop_email')"
                          size="small">
              <el-input disabled
                        :placeholder="`${$t('storeList.add.inputPlaceholder')}${$t('storeList.add.shop_email')}`"
                        maxlength="100"
                        v-model="detailForm.shop_email"
                        size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 @click="detailVisible = false">{{$t('storeList.add.close')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { cmofferApi }  from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            detailForm: {
                name: "",
                shop_abbr: "",
                platform_id: "",
                open_date: "",
                country: "",
                shop_email: "",
                shop_url: "",
                paypal: "",
                tax_number: "",
                pre_code: "",
                tel: "",
                status: 1,
                country_ids: [],
                track_id: "",
                customer: "",
                customer_email: "",
            },
            platformList: [],
            countryList: [],
            loading: false,
        };
    },
    methods: {
        closeDialog() {
            this.detailForm = {
                name: "",
                shop_abbr: "",
                platform_id: "",
                open_date: "",
                shop_email: "",
                shop_url: "",
                paypal: "",
                tax_number: "",
                pre_code: "",
                tel: "",
                status: 1,
                country_id: "",
                track_id: "",
                customer_email: "",
            };
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        /**
         * 获取详情
         */
        getShop() {
            this.loading = true;
            cmofferApi.shop({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.detailForm = res.data;
                    this.loading = false;
                }
            });
        },
    },
    props: ["detailVisible", "tableItem"],
    computed: {
        mixed() {
            const { tableItem, detailVisible } = this;
            return {
                tableItem,
                detailVisible,
            };
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                this.tableItem = newValue.tableItem;
                if (newValue.detailVisible) {
                    this.getShop();
                }
            },
            deep: true,
            immediate: false,
        },
    },
};
</script>
<style lang="scss">
.detail {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #333 !important;
                background: #fff;
                &:hover {
                    border-color: $color-primary;
                }
            }
        }
    }
}
</style>